import {t} from 'common/utils/translation-util';

// Parses the same payload structure that PeriodSelector takes as it's
// "options" prop, and returns a value map object that
// maps period option's slug to it's displayName.
// valueMap = {
//   period: {
//     label: 'Period',
//     fields: {
//       today: 'Today',
//       week: 'This week',
//       year: 'This year',
//     }
//   }
// }
export const getParsedPeriodSelectorOptions = (options) => {
  const result = {period: {label: t('Period'), fields: {}}};
  for (const option of options) {
    const {displayName, slug} = option;
    result.period.fields[slug] = displayName;
  }
  return result;
};

// Parses the same payload structure that DropdownFilter parses
// in parseCategorizedFields, but returns a value map object that
// is scoped by the category (parameter) and maps an option's
// id to it's displayName and label.
// valueMap = {
//   wow: {
//     1: {'displayName': 'one', 'label': 'Wow Label',},
//     3: {'displayName': 'three', 'label': 'Wow A Different Label!',},
//   },
//   totally: {
//     2: {'displayName': 'two', 'label': 'Totally Tubular',},
//     4: {'displayName': 'four', 'label': 'Totally Tubular',},
//    },
//  }
export const getParsedDropdownFilterOptions = (options) => {
  const result = {};
  for (const option of options) {
    if (!option) {
      continue;
    }
    const {fields, label, param} = option;
    if (!result[param]) {
      result[param] = {};
    }
    const fieldsMap = result[param] || {};
    for (const field of fields) {
      if (!fieldsMap[field.id]) {
        fieldsMap[field.id] = {};
      }
      fieldsMap[field.id].displayName = field.displayName;
      fieldsMap[field.id].label = label;
    }
    result[param] = fieldsMap;
  }
  return result;
};
